
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/conversation-sources/facebook/facebookPagesDialogView.tmpl");
    var Button = require("ui/button/Button");

    var FacebookPagesView = require("manager-views/data-sources/conversation-sources/facebook/FacebookPagesView");
    var FacebookPagesCollection = require("manager-collections/data-sources/conversation-sources/FacebookPagesCollection");

    var FacebookPagesDialogView = {};


    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {
        FacebookPagesDialogView = Marionette.Layout.extend({
            className: "facebook-dialog-container",
            template: template,
            ui: {
                facebookPageContainer: ".facebook-page-container",
                saveButton: ".facebook-page-save-btn"
            },
            uiComponents: {
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onDoneClick"
                    }
                }
            },
            events: {
            },

            initialize: function (options) {
                options = options || {};
                this.facebookPages = options.facebookPages || [];
                this.connectorModels = options.connectorModels || [];
                this.channel = LEManager.media.channel("conversationSources");
                this._bindEvents();
            },

            onRender: function() {
                this.facebookPagesCollection = new FacebookPagesCollection(this.facebookPages);
                this.facebookPagesView = new FacebookPagesView({el: this.ui.facebookPageContainer, collection: this.facebookPagesCollection, connectorModels: this.connectorModels});
                this.ui.facebookPageContainer.append(this.facebookPagesView.render().$el);

                _.defer(_.bind(function() {
                    LE.initFacebook();
                }, this));
            },

            refreshData: function(options) {
                this.connectorModels = options.connectorModels || [];
                this.facebookPagesView.setConnectorModels({connectorModels: this.connectorModels});
            },

            getFacebookPagesCollection: function() {
                return this.facebookPagesCollection;
            },

            getFacebookPagesView: function() {
                return this.facebookPagesView;
            },

            _bindEvents: function () {
                this.listenTo(this, "dialog:closeButtonClick", this._onCloseClick);
            },

            _onDoneClick: function () {
                LEManager.logger.debug("Close facebook subscribe page", "FacebookPagesDialogView:_onDoneClick");
                this._closeDialog();
            },

            _onCloseClick: function () {
                LEManager.logger.debug("dialog close button clicked", "FacebookPagesDialogView:_onCloseClick");
                this._closeDialog();
            },

            _closeDialog: function () {
                this.trigger("dialogInnerView:closeDialog");
            }
        });
    });

    return FacebookPagesDialogView;
});
